import React, { ReactNode, CSSProperties } from 'react'
import BasePopper, { PopperPlacementType } from '@mui/material/Popper'
import { ClickAwayListener } from '@mui/material'
import styled from 'particles/themes/styled'

const Container = styled(BasePopper)`
    width: fit-content;
    height: fit-content;
    min-width: 200px;
    min-height: 64px;
    padding: ${({ theme }) => theme.spacing[300]};
    box-sizing: border-box;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.surface.primary};
    box-shadow: ${({ theme }) => theme.shadows.level3};
    z-index: 999;
`
interface PopperProps {
    children: ReactNode
    anchorEl: null | HTMLElement
    placement?: PopperPlacementType
    disablePortal?: boolean
    onClose: () => void
    style?: CSSProperties
}

const Popper: React.FC<PopperProps> = ({ children, anchorEl, placement, onClose, disablePortal = true, style }) => {
    return (
        <ClickAwayListener
            onClickAway={() => {
                onClose()
            }}
        >
            <Container
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                placement={placement}
                //The portal disable required to work with setting parent component position to relative
                disablePortal={disablePortal}
                modifiers={[
                    {
                        name: 'flip',
                        enabled: true,
                    },
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 8],
                        },
                    },
                ]}
                style={style}
            >
                {children}
            </Container>
        </ClickAwayListener>
    )
}

export default Popper
